var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.596 22.588",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.54 0h1.5v3.054a8.306 8.306 0 015.19 2.475 8.021 8.021 0 011.411 1.949l-.535-.188c-.607-.216-1.216-.431-1.821-.65a.573.573 0 01-.2-.124 6.705 6.705 0 00-5.325-1.98 6.775 6.775 0 00-.922 13.372 6.59 6.59 0 006.227-1.81.735.735 0 01.245-.154c.721-.262 1.444-.519 2.167-.776a.311.311 0 01.139-.021 8.305 8.305 0 01-6.567 4.4v3.043h-1.5v-3.04a8.326 8.326 0 01-7.51-7.5H0v-1.507h2.898c.1 0 .146-.024.158-.137a8.116 8.116 0 012.285-4.867A8.186 8.186 0 0110.3 3.066c.241-.031.241-.031.241-.27V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.095 7.545l10.5 3.751-10.546 3.767c.047-.078.071-.12.1-.162q1.081-1.739 2.166-3.478a.209.209 0 000-.263q-1.087-1.736-2.166-3.478l-.064-.108z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoto);
export default __webpack_public_path__ + "static/media/goto.d036efca.svg";
export { ForwardRef as ReactComponent };